export const environment = {
  url: process.env.REACT_APP_API_URL || "https://api.miencuesta.app",
};
